<script setup>
    import { ref } from 'vue'
    import { useRoute } from 'vue-router'
    import Layout  from './components/layout/layout.vue'

    defineOptions({
        name: 'App'
    })

    const route = useRoute()
</script>


<template>
    <Layout v-if="!route.meta.noLayout">
        <router-view></router-view>
    </Layout>
    <router-view v-else></router-view>
</template>


<style>
  html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>